<mat-toolbar id="dialog-titlebar" mat-dialog-title color="primary">
  <span *ngIf="bundleId == null">Create Bundle</span>
  <span *ngIf="bundleId != null">Edit Bundle (ID: {{ bundleId }})</span>
</mat-toolbar>

<form
  #theForm
  [formGroup]="service.form"
  class="normal-form"
  (submit)="onSubmit(service.form.value)"
  [attr.data-testid]="bundleId == null ? 'create-bundle-dialog' : 'edit-bundle-dialog'"
  >
  <p-blockUI [blocked]="isCurtainBlocked"></p-blockUI>
  <div class="bundle-controls-container">
    <div class="bundle-controls-inputs" mat-dialog-content>
      <div class="bundle-controls-column">
        <input type="hidden" formControlName="$key" />
        <input type="hidden" formControlName="dateCreated" />
        <input type="hidden" formControlName="createdBy" />

        <mat-form-field appearance="outline">
          <mat-label>Bundle Name</mat-label>
          <input formControlName="name" matInput required data-testid="rb-bundle-name-input" />
          <mat-error>This field is mandatory.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Comma Separated Instrument S/N</mat-label>
          <input formControlName="instrumentSerialNumbers" matInput data-testid="rb-bundle-serial-input" />
        </mat-form-field>

        <div *ngIf="selectedBundleTypeId == 0 && showClinicalTrial" class="clinical-trial-container">
          <mat-checkbox
            color="primary"
            data-testid="rb-bundle-clinicaltrial-checkbox"
            [checked]="isClinicalTrialChecked"
            [disabled]="disableClinicalTrialCheckBox"
            (change)="toggleClinicalStatus()">
            Clinical Trial
          </mat-checkbox>
          <div *ngIf="isClinicalTrialChecked && !disableClinicalTrialCheckBox" class="clinical-trial-hint" id="ClinicalWarning">
            Cannot change after clicking OK
          </div>
        </div>
      </div>

      <div class="bundle-controls-column">
        <mat-form-field appearance="outline">
          <mat-label>Assay Type</mat-label>
          <mat-select formControlName="assayTypeCode" placeholder="Assay Type" data-testid="rb-bundle-assaytype-select">
            <mat-option *ngFor="let typeCode of assayTypeCodes" value="{{ typeCode.code }}">
              {{ typeCode | assayTypeCodeFormat }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="padding-right: 10px">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate" placeholder="Start Date" data-testid="rb-bundle-startdate-input" />
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" style="padding-right: 10px">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate" placeholder="End Date" data-testid="rb-bundle-enddate-input" />
          <mat-hint>MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="bundle-action-buttons" mat-dialog-actions>
      <button mat-raised-button color="warn" (click)="onCancel()" data-testid="rb-bundle-cancel-button">Cancel</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="service.form.invalid" data-testid="rb-bundle-ok-button">Ok</button>
    </div>
  </div>

  <div style="height: 20px; margin-top: 10px">
    <div *ngIf="!serialsAreValid" class="multi-field-validation-error alert">
      Must provide Instrument Serial Numbers (comma-separated numbers and letters)
    </div>
  </div>

  <div style="height: 20px; margin-top: 10px; margin-bottom: 10px">
    <div *ngIf="!datesAreValid" class="multi-field-validation-error alert">
      Must be valid dates and End Date > Start Date
    </div>
  </div>
</form>
